import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('payroll_components')
export class PayrollComponents {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @Column("int", {
        name: "employee_id"
    })
    employeeId: number;

    @Column('varchar', {
        name: 'employee_name',
    })
    employeeName: string;

    @Column('varchar', {
        name: 'employee_code',
    })
    employeeCode: string;

    @Column('varchar', {
        name: 'employee_type',
    })
    employeeType: string;

    @Column('varchar', {
        name: 'employee_category',
    })
    employeeCategory: string;

    @Column('int', {
        name: 'designation',
    })
    designation: number;

    @Column('int', {
        name: 'department',
    })
    department: number;

    @Column('int', {
        name: 'unit_id',
    })
    unitId: number;

    @Column("int", {
        name: "basic"
    })
    basic: number;


    @Column("int", {
        name: "hra_amount"
    })
    hraAmount: number;

    @Column("int", {
        name: "edu_amount"
    })
    eduAmount: number;

    @Column("int", {
        name: "medical_amount"
    })
    medicalAmount: number;

    @Column("int", {
        name: "spl_amount"
    })
    splAmount: number;

    @Column("int", {
        name: "conveyance_amount"
    })
    conveyanceAmount: number;

    @Column("int", {
        name: "petrol_Amount"
    })
    petrolAmount: number;

    @Column("int", {
        name: "shoe_amount"
    })
    shoeAmount: number;

    @Column("int", {
        name: "washing_amount"
    })
    washingAmount: number;

    @Column("int", {
        name: "uniform_amount"
    })
    uniformAmount: number;

    @Column("int", {
        name: "helper_amount"
    })
    helperAmount: number;

    @Column("int", {
        name: "production_amount"
    })
    productionAmount: number;
    @Column("int", {
        name: "ta_amount"
    })
    taAmount: number;
    @Column("int", {
        name: "bonus_amount"
    })
    bonusAmount: number;

    @Column("int", {
        name: "mess_d"
    })
    messAmount: number;
    @Column("int", {
        name: "others_d"
    })
    othersAmount: number;



    @Column('boolean', {
        name: 'is_active',
        default: true,
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;


    @Column("int", {
        name: "earnings"
    })
    earnings: number;

    @Column("int", {
        name: "tds"
    })
    tds: number;

    @Column("int", {
        name: "professional_tax"
    })
    professionalTax: number;

}